function getEventValueObject(e) {
  const { name, type } = e.target;
  const value = type === 'checkbox' ? e.target.checked : e.target.value;
  return { [name]: value };
}

export default getEventValueObject;